import { render, staticRenderFns } from "./jackpot-physical-prize.vue?vue&type=template&id=77158606"
import script from "./jackpot-physical-prize.vue?vue&type=script&lang=js"
export * from "./jackpot-physical-prize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77158606')) {
      api.createRecord('77158606', component.options)
    } else {
      api.reload('77158606', component.options)
    }
    module.hot.accept("./jackpot-physical-prize.vue?vue&type=template&id=77158606", function () {
      api.rerender('77158606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/jackpot-physical-prize.vue"
export default component.exports